// Central content + brand configuration for Brahmsara
import {
  BookOpen, Sparkles, Hourglass, Infinity as InfinityIcon,
  Waves, HandHeart, Layers, Wind,
} from "lucide-react";

export const CONTACT = {
  logo: "/assets/brahmsara-logo.png",
  founderImg: "/assets/shubham-jain.png",
  tagline: "Invoking Your Innate Consciousness",
  whatsapp: "https://wa.me/919999344645",
  whatsappDisplay: "+91 99993 44645",
  email: "shubham_soul@yahoo.com",
  instagram: "https://instagram.com/brahmsara_meditation",
  instagramHandle: "@brahmsara_meditation",
  youtube: "https://youtube.com/@Brahmsara",
  youtubeHindi: "https://youtube.com/@BrahmsaraHindi",
  googleReviews: "https://share.google/JWOVmONy70UhfpBrX",
};

export const SESSIONS = [
  {
    title: "Akashic Reading & Healing",
    price: "\u20B92,000",
    duration: "60 minutes \u00B7 Online, worldwide",
    desc: "A complete Akashic Records reading paired with compassionate energetic healing \u2014 to illuminate recurring patterns and gently release what no longer serves.",
    features: [
      "Personalised Akashic Records reading",
      "Akashic & energy healing",
      "Insight into karmic & soul patterns",
      "Complimentary post-session guidance & support",
    ],
    featured: true,
  },
  {
    title: "Tarot Card Reading & Guidance",
    price: "\u20B9999",
    duration: "30 minutes \u00B7 Online, worldwide",
    desc: "A thoughtful, symbol-led tarot session to bring clarity and confidence to meaningful crossroads and everyday life decisions.",
    features: [
      "Focused tarot guidance",
      "Clarity for specific questions",
      "Perspective on decisions ahead",
      "Complimentary post-session guidance & support",
    ],
    featured: false,
  },
];

export const BOOKS = [
  {
    title: "Solitude",
    subtitle: "Four Unsettling Tales of Desire, Obsession & Horror",
    note: "A haunting collection exploring the quiet, uncharted depths of the human heart.",
    store: "Amazon India",
    cover: "/assets/solitude.jpg",
    href: "https://www.amazon.in/Solitude-Unsettling-Obsession-Literature-Fiction-ebook/dp/B0FHXPDHPG",
  },
  {
    title: "The Night of Returning",
    subtitle: "A Novel",
    note: "An atmospheric tale of memory, longing and the paths that draw us home.",
    store: "Amazon",
    cover: "/assets/night-of-returning.webp",
    href: "https://www.amazon.com/dp/B0HBQTW961",
  },
];

export const NAV_LINKS = [
  { label: "About", id: "about" },
  { label: "Akashic", id: "akashic" },
  { label: "Services", id: "services" },
  { label: "Sessions", id: "sessions" },
  { label: "Process", id: "process" },
  { label: "Reviews", id: "testimonials" },
  { label: "Books", id: "books" },
  { label: "Meditations", id: "meditations" },
  { label: "FAQ", id: "faq" },
  { label: "Contact", id: "contact" },
];

export const SERVICES = [
  {
    icon: BookOpen,
    title: "Akashic Records Reading",
    desc: "A contemplative reading of your soul's record to illuminate recurring themes and offer gentle, grounded insight for the path ahead.",
  },
  {
    icon: Sparkles,
    title: "Akashic Healing",
    desc: "Compassionate energetic work within the Records to help release limiting patterns and invite a renewed sense of alignment.",
  },
  {
    icon: Hourglass,
    title: "Past-Life Exploration",
    desc: "A reflective practice exploring the echoes of earlier journeys, offered as a lens for understanding present-life patterns.",
  },
  {
    icon: InfinityIcon,
    title: "Soul & Karmic Pattern Guidance",
    desc: "Bring awareness to the repeating cycles that shape your relationships, choices and inner world — with clarity and care.",
  },
  {
    icon: Waves,
    title: "Energy Healing",
    desc: "A calming session designed to restore balance, ease tension and support the body's natural return to equilibrium.",
  },
  {
    icon: HandHeart,
    title: "Reiki Healing",
    desc: "Gentle, hands-light energy practice that encourages deep relaxation, emotional release and quiet restoration.",
  },
  {
    icon: Layers,
    title: "Tarot Guidance for Life Decisions",
    desc: "A thoughtful, symbol-led conversation to bring perspective and confidence to meaningful crossroads in your life.",
  },
  {
    icon: Wind,
    title: "Guided Meditation Practice",
    desc: "Softly guided practices for stillness, presence and self-discovery — accessible to beginners and seasoned practitioners alike.",
  },
];

export const PROCESS = [
  {
    n: "01",
    title: "Arrive & Settle",
    desc: "We begin with a gentle conversation to understand where you are, what you're carrying, and the questions living quietly within you.",
  },
  {
    n: "02",
    title: "Open the Space",
    desc: "Through prayer, intention and stillness, a safe and sacred space is opened — a place free of judgement, held with sincerity and respect.",
  },
  {
    n: "03",
    title: "Receive & Reflect",
    desc: "Insight is shared with care. Together we explore recurring patterns, energetic themes and the wisdom already present within you.",
  },
  {
    n: "04",
    title: "Integrate & Move Forward",
    desc: "You leave with grounded reflections and gentle practices to carry the work forward — toward clarity, healing and conscious choice.",
  },
];

export const TESTIMONIALS = [
  {
    quote: "One of the most insightful experiences I\u2019ve had. The reading helped me understand experiences from my past life and how they influence my present \u2014 and gave me clarity on the lessons and patterns to work on. Shubham was incredibly patient, kind and understanding, and I walked away with a much deeper sense of self-awareness.",
    name: "Ritika Karan",
    role: "Verified Google Review",
  },
  {
    quote: "I had a session just yesterday and I was absolutely amazed. All my questions were translated into what I was actually feeling \u2014 and no one knew about it. Shubham being so patient and accurate left me speechless.",
    name: "Mohini Arora",
    role: "Verified Google Review",
  },
  {
    quote: "I stumbled upon Brahmsara and booked a consultation for the life issues I was going through. Shubham gave clear insights \u2014 and a detailed reading on one aspect of my life I didn\u2019t even mention. It was very accurate.",
    name: "Rahul P R",
    role: "Verified Google Review",
  },
  {
    quote: "Thank you for the beautiful and deeply meaningful Akashic Records reading. The insights gave me a new perspective on my journey, and the healing and guidance filled me with hope and peace.",
    name: "Khushali P",
    role: "Verified Google Review",
  },
  {
    quote: "A truly insightful and meaningful experience. The reading was conducted with great compassion, patience and professionalism. What impressed me most was the depth of understanding and clarity that emerged.",
    name: "Nadir Gorimar",
    role: "Verified Google Review",
  },
  {
    quote: "At times we feel worried and clueless about why unpleasant things happen to us. Shubham acts as a supporting hand, helping make sense of it all with genuine care and clarity.",
    name: "Gaurav Agnihotri",
    role: "Verified Google Review",
  },
];

export const REVIEWS = [
  { name: "Rachna Gupta", text: "It gave me inspiration to move forward when I had almost lost hope. Thank you, Shubham.", stars: 5 },
  { name: "RRAHUL NAIR", text: "Got answers to my problems. Feeling very light and happy after the session.", stars: 5 },
  { name: "Verified Client", text: "A wonderful Akashic Records reading \u2014 insightful, comforting and gently clarifying. Highly recommend.", stars: 5 },
];

export const FAQS = [
  {
    q: "What are the Akashic Records?",
    a: "The Akashic Records are often described as an energetic archive of the soul's journey — its intentions, experiences and patterns. A reading is offered as a contemplative practice to support self-reflection, healing and personal growth, not as prediction or diagnosis.",
  },
  {
    q: "Do I need to prepare anything for a session?",
    a: "Simply arrive with an open heart and, if you like, a few questions or areas of life you'd like to explore. Sessions are gentle, conversational and entirely at your pace.",
  },
  {
    q: "Are sessions available online?",
    a: "Yes \u2014 all sessions are conducted virtually, so you can connect from any part of the world and experience the same calm, focused space from wherever you are.",
  },
  {
    q: "Is this a religious practice?",
    a: "No. Brahmsara is a non-denominational, inclusive spiritual practice. It welcomes people of all backgrounds and beliefs, and is intended to complement — never replace — professional medical or psychological care.",
  },
  {
    q: "How long is a typical session?",
    a: "An Akashic Reading & Healing session runs for 60 minutes and a Tarot Guidance session for 30 minutes. Post-session guidance and support is always included, complimentary.",
  },
  {
    q: "How do I book?",
    a: "You can book directly via WhatsApp or email. Reach out with your preferred practice and a time that suits you, and we'll take care of the rest.",
  },
];

export const MEDITATIONS = {
  english: [
    { id: "2MmAjDwBf1g", title: "Past Life Regression Meditation", desc: "A safe, guided hypnosis journey into the echoes of earlier lifetimes.", featured: true },
    { id: "ljwmdXmIPOU", title: "Self Love Meditation for Deep Healing", desc: "A gentle inner-child practice for compassion and healing." },
    { id: "GzHUcEfPwJI", title: "Divine Protection Overnight Affirmations", desc: "Restful affirmations to let play through the night." },
  ],
  hindi: [
    { id: "4mT6dwRLE-0", title: "Gratitude Sleep Meditation", desc: "\u0938\u094B\u0924\u0947 \u0938\u092E\u092F \u0915\u0943\u0924\u091C\u094D\u091E\u0924\u093E \u2014 an overnight gratitude practice.", featured: true },
    { id: "mZMUcZFoVEI", title: "Guided Manifestation Meditation", desc: "\u0905\u092A\u0928\u0947 \u0906\u0926\u0930\u094D\u0936 \u091C\u0940\u0935\u0928 \u0915\u0940 \u0915\u0932\u094D\u092A\u0928\u093E \u2014 Law of Attraction." },
    { id: "MD97LnW1wFU", title: "Connecting with the Divine", desc: "Instant positivity and divine energy through guided stillness." },
  ],
};

export const IMAGES = {
  hero: "/assets/cosmic-ring.png",
  founder: "/assets/shubham-jain.png",
  cosmic: "/assets/cosmic-ring.png",
  architecture: "/assets/portal.jpg",
  nature: "/assets/akashic-book.jpg",
  studio: "/assets/cosmic-ring.png",
  logo: "/assets/brahmsara-logo.png",
  ig1: "/assets/instagram3.jpg",
  ig2: "/assets/instagram2.jpg",
  ig3: "/assets/instagram1.jpg",
};

// Build a WhatsApp link with a pre-filled message
export const waLink = (text) =>
  `${CONTACT.whatsapp}?text=${encodeURIComponent(text)}`;

export const FOUNDER_BIO = [
  "Shubham Jain is an Akashic Records Practitioner, Spiritual Guide, Reiki Healer, Tarot Reader, Author and Meditation Guide, dedicated to helping individuals reconnect with their inner wisdom and navigate life with greater clarity, purpose and peace.",
  "With a background in storytelling and years of experience in communication, Shubham brings a thoughtful, compassionate and deeply intuitive approach to every session. His work is rooted in the belief that every individual carries a unique soul journey, and that greater awareness of recurring life patterns can inspire healing, self-understanding and conscious transformation.",
  "Through Brahmsara, Shubham offers personalized Akashic Records Readings, Akashic Healing, Reiki Healing, Tarot Guidance and guided meditation practices — designed to provide insight into recurring emotional and karmic patterns, support energetic healing, and empower aligned decisions made with confidence and clarity.",
  "Known for his empathetic presence and grounded approach, Shubham creates a safe, non-judgemental space where clients can explore life's deeper questions, release limiting patterns and cultivate a stronger connection with themselves.",
  "In addition to his private practice, Shubham is the author of two published novels and the creator of Brahmsara — a meditation platform dedicated to making mindfulness, self-discovery and inner transformation accessible through thoughtfully guided meditations and spiritual teachings.",
];
